module.exports = __webpack_public_path__ + "img/keyboard-right-arrow-button-1_icon-icons.com_72690.34790c23.png";